import { render, staticRenderFns } from "./EditMarketGoods.vue?vue&type=template&id=083ca9be"
import script from "./EditMarketGoods.vue?vue&type=script&lang=js"
export * from "./EditMarketGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports